export default __webpack_public_path__ + "static/media/sleep.24d4d79c.gif";